export const LK_TABLE_CELL_TYPE = {
  STRING: 'STRING',
  DATE: 'DATE',
  TEMPLATE: 'TEMPLATE',
}



// WEBPACK FOOTER //
// ./src/templates/components/lk/lk-table/data/lk.table.data.js